const barStyle = {
    background: "#2a2a2a", // light black
    color: "#fff",
    textAlign: "center",
    padding: "10px 0", // reduced vertical padding for thinner bar
    position: "relative",
    cursor: "pointer",
};

const arrowStyle = {
    display: "inline-block",
    width: 0,
    height: 0,
    borderLeft: "12px solid transparent", // smaller arrow
    borderRight: "12px solid transparent",
    borderBottom: "12px solid #fff",
    marginBottom: "6px",
};

function BackToTopBar() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // smooth scroll animation
        });
    };

    return (
        <div
            style={barStyle}
            onClick={scrollToTop}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
                if (e.key === "Enter") scrollToTop();
            }}
            aria-label="Scroll to top"
        >
            <div style={arrowStyle} />
            <div
                style={{
                    marginTop: "4px",
                    fontSize: "9px", // smaller font size
                    letterSpacing: "1px",
                    userSelect: "none",
                }}
            >
                BACK TO TOP
            </div>
        </div>
    );
}

export default BackToTopBar;
